import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { PlanFindingsResponse } from '@core/models/plan-finding.model';

export const PlanFindingsActions = createActionGroup({
  source: 'PlanFindings',
  events: {
    'Context Changed': props<{ planId: string; paramId: number }>(),
    /** The plan names no parameter set and its solver lists none, so it cannot be checked. */
    'Context Unavailable': props<{ planId: string }>(),
    'Read Requested': props<{ planId: string; paramId: number }>(),
    'Read Succeeded': props<{
      response: PlanFindingsResponse;
      planId: string;
      paramId: number;
    }>(),
    /** The user asked for a check of whatever plan is in view. */
    'Check Asked': emptyProps(),
    'Check Requested': props<{ planId: string; paramId: number }>(),
    'Check Succeeded': props<{
      response: PlanFindingsResponse;
      planId: string;
      paramId: number;
      editSeq: number;
    }>(),
    'Request Failed': props<{ error: string; planId: string; paramId: number }>(),
    'Plan Data Changed': props<{ planId: string }>()
  }
});
